import axios from "axios";
import { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { getAllUrlParams } from "./global";
import { useLoginStore } from "./state";

export const Verifyauth = () => {
  const [searchParams] = useSearchParams();
  const redirect = searchParams.get("redirect");
  const navigate = useNavigate();
  const url = window.location.href;
  const { updateLoginField } = useLoginStore();

  useEffect(() => {
    var CryptoJS = require("crypto-js");
    const params = getAllUrlParams(url);
    let SECRET_KEY = "TABUNGHAJI@WEB";
    var bytes = CryptoJS.AES.decrypt(params.token, SECRET_KEY);
    var originalText = bytes.toString(CryptoJS.enc.Utf8);
    let final = originalText.slice(1, -1);
    let encryptjwt = CryptoJS.AES.encrypt(final, `${process.env.SECRET_KEY}`);
    updateLoginField("jwtToken", encryptjwt.toString());
    const currentTimestamp = Date.now();
    updateLoginField("lastVisited", currentTimestamp);
    axios
      .get(`${process.env.REACT_APP_API_URL}/api/users/me`, {
        headers: { Authorization: `Bearer ${final}` },
      })
      .then((result) => {
        console.log(result);

        updateLoginField("user", result.data);
        updateLoginField("id", result.data.id);
        updateLoginField("username", result.data.username);
        updateLoginField("email", result.data.email);
        axios
          .get(
            `${process.env.REACT_APP_API_URL}/api/users/${result.data.id}?populate[0]=pekta&populate[1]=pekta.pekta_applications&populate[2]=pekta.pihtas_applications`,
            {
              headers: { Authorization: `Bearer ${final}` },
            }
          )
          .then((response) => {
            if (response.data.pekta === null) {
              updateLoginField("havePekta", "no");
              updateLoginField("pektaAppStatus", "none");
            } else {
              let pektaApp = response.data.pekta.pekta_applications;
              let pektaAppStatus =
                response.data.pekta.pekta_applications[pektaApp.length - 1]
                  .status;
              updateLoginField("havePekta", "yes");
              updateLoginField("pektaAppStatus", pektaAppStatus);
              updateLoginField("pektaID", response.data.pekta.id);
            }
          })
          .then(navigate(`/${redirect}`), window.location.reload())
          .catch((error) => {
            // Handle error.
            console.log("An error occurred:", error);
            navigate("/login");
          });
      })
      .catch((error) => {
        console.log("An error occured:", error);
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [redirect]);

  return <></>;
};
